export default "__VITE_ASSET__pjs0AKaB__"